import { Any, isAny } from './any';
import { All, isAll } from './all';
import { Rule, isRule } from './rule';
import { Entry } from './entry';
import { FactFunction } from './fact-function';
import { operators } from './operators';

export interface RuleEngineParams {
  facts: { [factName: string]: FactFunction };
}

export class RuleEngine {
  constructor(private params: RuleEngineParams) {}

  public run(rule: Entry): boolean | Promise<boolean> {
    if (!rule) {
      return true;
    }

    if (isAny(rule)) {
      return this.runAny(rule);
    } else if (isAll(rule)) {
      return this.runAll(rule);
    } else if (isRule(rule)) {
      return this.runRule(rule);
    }

    throw new Error('unexpected rule engine entry');
  }

  private async runAny(rule: Any) {
    const children = await Promise.all(rule.any.map((rule) => this.run(rule)));

    return children.some(Boolean);
  }

  private async runAll(rule: All) {
    const children = await Promise.all(rule.all.map((rule) => this.run(rule)));

    return children.every(Boolean);
  }

  private async runRule(rule: Rule) {
    const factFunction = this.params.facts[rule.fact];

    if (!factFunction) {
      throw new Error(`no generator function for fact ${rule.fact} found`);
    }

    const result = await factFunction();
    const operator = operators[rule.operator];

    if (!operator) {
      throw new Error(`no operator ${rule.operator} found`);
    }

    return operator(result, rule.value);
  }
}
